var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgClear = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.85 16.44C17.9446 16.5339 17.9979 16.6617 17.9979 16.795C17.9979 16.9283 17.9446 17.0561 17.85 17.15L17.15 17.85C17.0561 17.9446 16.9283 17.9979 16.795 17.9979C16.6617 17.9979 16.5339 17.9446 16.44 17.85L12 13.41L7.55997 17.85C7.46609 17.9446 7.33829 17.9979 7.20497 17.9979C7.07166 17.9979 6.94386 17.9446 6.84997 17.85L6.14997 17.15C6.05532 17.0561 6.00208 16.9283 6.00208 16.795C6.00208 16.6617 6.05532 16.5339 6.14997 16.44L10.59 12L6.14997 7.55997C6.05532 7.46609 6.00208 7.33829 6.00208 7.20497C6.00208 7.07166 6.05532 6.94386 6.14997 6.84997L6.84997 6.14997C6.94386 6.05532 7.07166 6.00208 7.20497 6.00208C7.33829 6.00208 7.46609 6.05532 7.55997 6.14997L12 10.59L16.44 6.14997C16.5339 6.05532 16.6617 6.00208 16.795 6.00208C16.9283 6.00208 17.0561 6.05532 17.15 6.14997L17.85 6.84997C17.9446 6.94386 17.9979 7.07166 17.9979 7.20497C17.9979 7.33829 17.9446 7.46609 17.85 7.55997L13.41 12L17.85 16.44Z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgClear, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/clear.900a6ad4.svg";
export { ForwardRef as ReactComponent };